
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CakeIcon from '@mui/icons-material/Cake';
import TtkList from './TtkList';
const CakeShopTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-6'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Popular Flavour :</b>&nbsp;<TtkList data={data?.popularFlavourCake} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CakeIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Cakes Shapes:</b>&nbsp;<TtkList data={data?.cakesShape} /></p>
                        </div>



                    </div>
                    <div className='row'>
                        <div className='col-md-3'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving Cities :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-6'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Specialty:</b>&nbsp;<TtkList data={data?.specialtyCake} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Price:</b>&nbsp;<span>{data?.price}</span></p>
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}

export default CakeShopTTK